import React from "react";
import { ITopBannerWarning } from "./Interface";
import "./TopBannerWarning.scss";

export const TopBannerWarning = (props: ITopBannerWarning) => props.visible ? (
    <div className="top-banner-waring">
        {props.text}
    </div>
) : null;
